<script setup lang="ts">
  import { computed } from 'vue';

  const props = withDefaults(defineProps<{ title: string; value: unknown; open?: boolean }>(), { open: false });

  const json = computed(() => JSON.stringify(props.value ?? null, null, 2));
</script>

<template>
  <details
    class="group rounded-md border border-[var(--color-gray-02)]"
    :open="open"
  >
    <summary class="flex cursor-pointer items-center gap-2 px-2 py-1.5 font-medium text-[var(--color-gray-07)]">
      <span class="text-[var(--color-gray-04)] transition-transform group-open:rotate-90">›</span>
      <span class="flex-1">{{ title }}</span>
      <code class="text-[10px] text-[var(--color-gray-04)]">JSON</code>
    </summary>
    <pre class="max-h-64 overflow-auto border-t border-[var(--color-gray-02)] bg-[var(--color-gray-09)] p-2 text-[10px] leading-snug">{{ json }}</pre>
  </details>
</template>
